export default "__VITE_ASSET__N0WdDmPp__"